'use strict';

const marketingIdAction = 'MarketingID';

export default function marketingId($location, analytics) {
  'ngInject';

  return {

    /**
     * Fires `Marketing ID` analytics event if marketing id is present in search query;
     */
    init: function () {
      var marketingId = $location.search().mid;

      if (marketingId) {
        analytics.track(marketingIdAction, {
          value: marketingId
        });
      }
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/marketing_id.js